import { render, staticRenderFns } from "./NewValue.vue?vue&type=template&id=31c5d94d&"
import script from "./NewValue.vue?vue&type=script&lang=js&"
export * from "./NewValue.vue?vue&type=script&lang=js&"
import style0 from "./NewValue.vue?vue&type=style&index=0&id=31c5d94d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports